import React, { useRef, useEffect, useState, useContext } from 'react';
import './RelatedProducts.css'
// import data_product from '../Assets/data'
import Item from '../Item/Item'
import arrow from '../../assets/arrow.png'

const RelatedProducts = (props) => {
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  const {product} = props;
  const [category, setCategory] = useState(''); 
  const [page, setPage] = useState(1); // Current page
  const [limit, setLimit] = useState(10); // Items per page
  const [hasMore, setHasMore] = useState(true); 
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProducts = async () => {
      setLoading(true);
      try {
          const query = new URLSearchParams({
              category,
              page: page.toString(),
              limit: limit.toString(),
          }).toString();
  
          const response = await fetch(`${databaseUrl}/allproducts?${query}`);
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
  
          const data = await response.json();
          if(page === 1 ) setProducts(data.products);
          else setProducts((prev) => [...prev, ...data.products]);
  
          if (products.length + data.products.length >= data.total) {
              setHasMore(false);
          } 
          else setHasMore(true);
      } catch (error) {
          console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchProducts();
    }, [category, page, limit]);
  
    const loadMore = () => {
      if (hasMore) {
          setPage((prev) => prev + 1); // Increment page number
      }
    };

  useEffect(() => {
    setCategory(product.category);
  }, [product.category]);

    // useEffect(() => {
    //     // if(localStorage.getItem('auth-token')){
    //         fetch(`${databaseUrl}/getrelatedproducts`,{
    //             method:'POST',
    //             headers:{
    //                 Accept:'application/form-data',
    //                 'Content-Type':'application/json',
    //             },
    //             body:JSON.stringify({"category":product.category}),
    //         }).then((response)=>response.json()).then((data)=>setRelated(data));
    //     // }
    // },[product.category])

    const scrollContainerRef = useRef(null);

    useEffect(() => {
      const scrollContainer = scrollContainerRef.current;
      if (!scrollContainer) return; // Check if scrollContainer is null
      const handleScroll = () => {
        clearTimeout(window.scrollTimeout);
        window.scrollTimeout = setTimeout(() => {
          const container = scrollContainer;
          const items = container.querySelectorAll('.item');
          const containerRect = container.getBoundingClientRect();
          const containerCenterX = containerRect.left + containerRect.width / 2;

          let closestItem;
          let minDistance = Infinity;

          items.forEach((item) => {
            const itemRect = item.getBoundingClientRect();
            const itemCenterX = itemRect.left + itemRect.width / 2;
            const distance = Math.abs(itemCenterX - containerCenterX);

            if (distance < minDistance) {
              closestItem = item;
              minDistance = distance;
            }
          });

          if (closestItem) {
            container.scrollTo({
              left:
                closestItem.offsetLeft -
                container.offsetWidth / 2 +
                closestItem.offsetWidth / 2,
              behavior: 'smooth',
            });
          }
        }, 150); // Adjust this timeout value as needed
      };

      if (scrollContainer) { // Check if scrollContainer is not null before adding event listener
        scrollContainer.addEventListener('scroll', handleScroll);
      }
      
      return () => {
        if (scrollContainer) { // Check if scrollContainer is not null before removing event listener
          scrollContainer.removeEventListener('scroll', handleScroll);
        }
      };
    }, [scrollContainerRef.current]); // Ensure useEffect runs when scrollContainerRef changes


  return (
    <div className='mt-16 mb-20 px-[3%] md:px-[5%] lg:px-[10%]'>
      <h1 className="text-4xl md:text-5xl text-center font-medium mb-12 text-[#551E19]">Related Products</h1>
      <hr/>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4" ref={scrollContainerRef}>
        {products.map((item) => (
          <div className="font-montserrat" key={item._id}>
            <Item
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
              rating={item.rating}
              reviewText={item.reviewText}
              no_of_rators={item.no_of_rators}
              category={item.category}
              available={item.available}
            />
          </div>
        ))}
      </div>
      {hasMore && !loading && (
        <div className='py-6 flex items-center justify-center mt-8'>
          <button onClick={loadMore} className="bg-[#E6B17E] text-[#551e19] px-7 py-3 text-lg rounded-3xl hover:bg-[#c98c3c] flex items-center font-oswald">
            Load More <img src={arrow} className="ml-2 h-4 w-4" />
          </button>
        </div>
      )}

      {loading && <p className='text-black text-lg mt-32'>Loading...</p>}

      {!hasMore && !loading && (
        <p className="text-[#551e19] text-xs mt-5 text-center">
          No more products to load.
        </p>
      )}
    </div>
  )
}

export default RelatedProducts
